import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShopboxCommonModule } from '@shared/common/common.module';
import { ClientProfileComponent, ClientImageComponent } from './components';


@NgModule({
    imports: [
        CommonModule,
        ShopboxCommonModule,
        ClientProfileComponent, ClientImageComponent
    ],
    exports: [
        ClientProfileComponent
    ]
})
export class ProfileModule { }
